import {StoryDetailPageContext} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {trackContentView} from './trackContentView';

export const trackStoryView =
  ({page}: {page: StoryDetailPageContext}) =>
  (clientState: TrackingClientStateHolder) => {
    return trackContentView({page})(clientState);
  };
